"use strict";
/* eslint-disable max-lines-per-function */
/** @jsx jsx */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomepageScreen = void 0;
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const core_1 = require("@emotion/core");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const components_1 = require("@/components");
const stateful_nav_item_1 = __importDefault(require("@/components/stateful-nav-item"));
const constants_1 = __importStar(require("@/constants"));
const modals_1 = require("@/modals");
const redux_1 = require("@/redux");
const api_payloads_1 = require("@/redux/api-payloads");
const subscribe_1 = __importDefault(require("@/screens/subscribe"));
const subscriptions_1 = __importDefault(require("@/screens/subscriptions"));
const wallet_connection_1 = __importDefault(require("@/screens/wallet-connection"));
const selectors_1 = __importDefault(require("@/selectors"));
const context_1 = __importDefault(require("../context"));
const styled_react_1 = __importDefault(require("./styled-react"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
var Screens;
(function (Screens) {
    Screens[Screens["Profile"] = 0] = "Profile";
    Screens[Screens["Subscriptions"] = 1] = "Subscriptions";
    Screens[Screens["Subscribe"] = 2] = "Subscribe";
    Screens[Screens["WalletConnection"] = 3] = "WalletConnection";
})(Screens || (Screens = {}));
const getScreenfromPath = (location) => {
    let screen = null;
    switch (location) {
        case constants_1.Routes.Subscriptions:
            screen = Screens.Subscriptions;
            break;
        case constants_1.Routes.Subscribe:
            screen = Screens.Subscribe;
            break;
        case constants_1.Routes.WalletConnection:
            screen = Screens.WalletConnection;
            break;
        default:
            screen = Screens.Profile;
    }
    return screen;
};
const HomepageScreen = ({ user, journeys, logOut, paymentPortalSessionUrl, paymentPortalSessionError, createPaymentPortalSession, clearPaymentPortalSessionError }) => {
    const { navOpen, closeNav } = (0, react_1.useContext)(context_1.default);
    const location = (0, react_router_1.useLocation)();
    // const [paymentPortalSessionUrlLocal, setPaymentPortalSessionUrlLocal] = useState<string>(paymentPortalSessionUrl)
    const [screen, setScreen] = (0, react_1.useState)(getScreenfromPath(location.pathname));
    (0, react_1.useEffect)(() => {
        setScreen(getScreenfromPath(location.pathname));
    }, [location]);
    (0, react_1.useEffect)(() => {
        if (paymentPortalSessionUrl) {
            window.location.href = paymentPortalSessionUrl;
        }
    }, [paymentPortalSessionUrl]);
    if (location.search.includes("reset")) {
        return (0, core_1.jsx)(react_router_1.Redirect, { to: constants_1.Routes.ResetPasswordChange + location.search });
    }
    if (!user) {
        return (0, core_1.jsx)(react_router_1.Redirect, { to: constants_1.Routes.Login });
    }
    if (user && location.pathname === '/') {
        return (0, core_1.jsx)(react_router_1.Redirect, { to: constants_1.Routes.Subscriptions });
    }
    const handleOnClickPaymentPortal = () => __awaiter(void 0, void 0, void 0, function* () {
        yield createPaymentPortalSession();
    });
    const handleLogout = () => {
        closeNav();
        logOut();
    };
    return ((0, core_1.jsx)("div", { className: styles_scss_1.default.backdrop },
        (0, core_1.jsx)("div", { className: styles_scss_1.default.sideNav, css: styled_react_1.default.navOpen(navOpen) },
            (0, core_1.jsx)(components_1.SideNav, { className: styles_scss_1.default.sideNavFlex },
                (0, core_1.jsx)("div", null,
                    (0, core_1.jsx)(stateful_nav_item_1.default, { icon: constants_1.Images.user, path: constants_1.Routes.Profile, label: constants_1.default.nav.profile, selected: screen === Screens.Profile, onClick: () => {
                            closeNav();
                            setScreen(Screens.Profile);
                        } }),
                    (0, core_1.jsx)(stateful_nav_item_1.default, { icon: constants_1.Images.subscriptions, path: constants_1.Routes.Subscriptions, label: constants_1.default.nav.subscriptions, selected: screen === Screens.Subscriptions, onClick: () => {
                            closeNav();
                            setScreen(Screens.Subscriptions);
                        } }),
                    (0, core_1.jsx)(stateful_nav_item_1.default, { icon: constants_1.Images.creditCard, path: constants_1.Routes.Subscriptions, label: constants_1.default.nav.paymentPortal, selected: undefined, onClick: handleOnClickPaymentPortal }),
                    (0, core_1.jsx)(stateful_nav_item_1.default, { icon: constants_1.Images.walletConnection, path: constants_1.Routes.WalletConnection, label: constants_1.default.nav.connectWallet, selected: screen === Screens.WalletConnection, onClick: () => {
                            closeNav();
                            setScreen(3);
                        } })),
                (0, core_1.jsx)("div", { className: styles_scss_1.default.navLogout }, user && ((0, core_1.jsx)(components_1.Button, { className: styles_scss_1.default.signUpButton, onClick: handleLogout }, constants_1.default.login.logOut))))),
        (0, core_1.jsx)("main", { className: styles_scss_1.default.container, css: styled_react_1.default.contentNavMode(navOpen) }, (screen === Screens.Subscribe && (0, core_1.jsx)(subscribe_1.default, { location: location })) ||
            (screen === Screens.Subscriptions && (0, core_1.jsx)(subscriptions_1.default, { location: location })) ||
            (screen === Screens.WalletConnection && (0, core_1.jsx)(wallet_connection_1.default, { location: location })) || ((0, core_1.jsx)(components_1.Profile, { user: user, journeys: journeys }))),
        paymentPortalSessionError ? (0, core_1.jsx)(modals_1.PaymentPortalSessionErrorModal, { paymentPortalSessionError: paymentPortalSessionError, onClearError: clearPaymentPortalSessionError }) : null));
};
exports.HomepageScreen = HomepageScreen;
const mapStateToProps = (state) => ({
    paymentPortalSessionError: selectors_1.default.payment.getPaymentPortalSessionError(state),
    paymentPortalSessionUrl: selectors_1.default.payment.getPaymentPortalSession(state),
    user: selectors_1.default.user.getUser(state),
    journeys: selectors_1.default.user.getActiveHabitJourneys(state),
});
const mapDispatchToProps = (dispatch) => ({
    logOut: () => redux_1.ActionCreators.user.logOut.dispatch(),
    clearPaymentPortalSessionError: () => dispatch(redux_1.ActionCreators.payment.clearPaymentPortalSessionError),
    createPaymentPortalSession: () => dispatch(radio_dispatch_1.reduxSet.makeRequest.dispatch((0, api_payloads_1.createPaymentPortalSession)())),
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(exports.HomepageScreen);
